export default "__VITE_ASSET__CpGA5m7Z__"